import Datadog from './datadog'

const datadog = new Datadog()
datadog.init()
